import angular from "angular";

angular
    .module('app')
    .component('customerUsersControl', {
        controller: ['$uibModal', 'notifier', '$http', controller],
        template: require('./customer-users-control.html'),
        bindings: {
            roles: '<'
        }
    });

function controller($uibModal, notifier, $http) {

    let $ctrl = this;

    $ctrl.search = null;
    $ctrl.status = null;
    $ctrl.currentPage = 1;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/users/get-list', {
                params: {
                    search: $ctrl.search,
                    status: $ctrl.status,
                    page: $ctrl.currentPage,
                }
            })
            .then(res => {
                $ctrl.users = res.data.data;
                $ctrl.totalCount = res.data.count;
            })
            .catch(err => {
                notifier.errorResponseNotify(error);
            });
    };

    $ctrl.edit = function (user) {
        $uibModal
            .open({
                component: 'customerUserForm',
                resolve: {
                    user: function () {
                        return user;
                    },
                    roles: function () {
                        return $ctrl.roles;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    $ctrl.getList();
                },
                function () {
                },
            );
    };

}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/customer-users-control/customer-users-control.js